export default "__VITE_ASSET__162c7964__"